var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.74341 6.78011C1.10453 6.36224 1.73602 6.31625 2.15389 6.67737L9.99765 13.4561L17.8406 6.67814C18.2585 6.31702 18.89 6.36302 19.2511 6.78089C19.6122 7.19875 19.5662 7.83024 19.1483 8.19136L10.6515 15.5344C10.276 15.8589 9.71929 15.8589 9.34378 15.5344L0.846146 8.19058C0.428284 7.82946 0.382287 7.19797 0.74341 6.78011Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63636 8C2.23658 8 2 8.29585 2 8.55556V19.4444C2 19.7042 2.23658 20 2.63636 20H17.3636C17.7634 20 18 19.7042 18 19.4444V8.55556C18 8.29585 17.7634 8 17.3636 8H2.63636ZM0 8.55556C0 7.09704 1.22867 6 2.63636 6H17.3636C18.7713 6 20 7.09704 20 8.55556V19.4444C20 20.903 18.7713 22 17.3636 22H2.63636C1.22867 22 0 20.903 0 19.4444V8.55556Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63672 3C4.63672 2.44772 5.08443 2 5.63672 2H21.364C22.7717 2 24.0004 3.09704 24.0004 4.55556V16.4444C24.0004 16.9967 23.5526 17.4444 23.0004 17.4444C22.4481 17.4444 22.0004 16.9967 22.0004 16.4444V4.55556C22.0004 4.29585 21.7638 4 21.364 4H5.63672C5.08443 4 4.63672 3.55228 4.63672 3Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGroup);
export default __webpack_public_path__ + "static/media/email_group.9f3a84d67341e7e1b865af48da192035.svg";
export { ForwardRef as ReactComponent };